export default "__VITE_ASSET__BHQ6OK5H__"